import { render, staticRenderFns } from "./PartnershipType.vue?vue&type=template&id=3d74087c&scoped=true&"
import script from "./PartnershipType.vue?vue&type=script&lang=js&"
export * from "./PartnershipType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d74087c",
  null
  
)

export default component.exports